import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './FilterComponent.scss';
import clsx from 'clsx';

interface Props {
	value: Date | null | string | number;
	children: JSX.Element;
	isLoading?: boolean;
	isGrey?: boolean;
	label?: string;
	labelPlacement?: 'integrated' | 'above';
	cypressAttribute?: string;
}

export const FilterComponent: FC<Props> = (props) => {
	const { children, value, isLoading, isGrey, label, labelPlacement, cypressAttribute = 'filter-component' } = props;

	const getFilterStartIcon = (): JSX.Element => {
		if (!value) {
			return (
				<div className="filter-icon position-absolute" data-cy="filter-icon">
					<FontAwesomeIcon icon={faPlus} width={7} />
				</div>
			);
		}

		if (value && labelPlacement === 'integrated') {
			return (
				<span className="fs-9 text-muted me-1" data-cy="filter-icon-with-label">{label} |</span>
			);
		}
	};
	return (
		<div className={clsx('position-relative', labelPlacement === 'above' && 'pt-4')} data-cy={cypressAttribute}>
			{
				labelPlacement === 'above' && (
					<div className="text-muted fs-9 position-absolute filter-label">{!!value && label}</div>
				)
			}
			<div className={clsx('d-flex align-items-center filter-item-wrap px-3 py-1 position-relative',
				isLoading && 'cursor-not-allowed',
				isGrey && 'grey-bgc'
			)}>
				{/*{*/}
				{/*	!value && (*/}
				{/*		<div className="filter-icon me-2 position-absolute">*/}
				{/*			<FontAwesomeIcon icon={faPlus} width={7}/>*/}
				{/*		</div>*/}
				{/*	)*/}
				{/*}*/}
				{getFilterStartIcon()}
				{children}
			</div>
		</div>
	);
};
